import { render, staticRenderFns } from "./BusinessSignUp.vue?vue&type=template&id=a059cc2a&scoped=true&"
import script from "./BusinessSignUp.vue?vue&type=script&lang=js&"
export * from "./BusinessSignUp.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSignUp.vue?vue&type=style&index=0&id=a059cc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a059cc2a",
  null
  
)

export default component.exports